/**
 * Route for `predictive-anomaly-detection`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { PredictiveAnomalyDetectionPage } from "../features/predictive-anomaly-detection/PredictiveAnomalyDetectionPage";

export const predictiveAnomalyDetectionRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/predictive-anomaly-detection",
	component: PredictiveAnomalyDetectionPage,
});

export default predictiveAnomalyDetectionRoute;
